<template>
  <div id="app">
    <Game/>
  </div>
</template>

<script>
import Timer from './components/Timer'
import Game from './components/Game'

export default {
  name: 'App',
  components: {
    Timer, Game
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue